/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Paragraphs_0Inputs */

const en_gc_search_guides_gridcraft_excel_compatibility_sections_2_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For a clean test, create the following cells in a blank workbook. B4 should initially show 165 and B5 should show Review. Change B2 from 120 to 130: B4 should become 175 while B5 stays Review. Repeat the check after saving and reopening. This tests a range formula, a dependent formula and recalculation with known results.`)
};

const zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_paragraphs_0 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Paragraphs_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在空白工作簿中输入下方五个单元格。B4 最初应为 165，B5 应为 Review。将 B2 从 120 改为 130 后，B4 应变为 175，B5 仍为 Review。保存并重新打开后再检查一次，即可验证范围公式、依赖公式及重新计算的结果。`)
};

/**
* | output |
* | --- |
* | "For a clean test, create the following cells in a blank workbook. B4 should initially show 165 and B5 should show Review. Change B2 from 120 to 130: B4 shoul..." |
*
* @param {Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Paragraphs_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_excel_compatibility_sections_2_paragraphs_0 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Paragraphs_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Excel_Compatibility_Sections_2_Paragraphs_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_excel_compatibility_sections_2_paragraphs_0(inputs)
	return zh_gc_search_guides_gridcraft_excel_compatibility_sections_2_paragraphs_0(inputs)
});
export { gc_search_guides_gridcraft_excel_compatibility_sections_2_paragraphs_0 as "gc.search_guides.gridcraft_excel_compatibility.sections.2.paragraphs.0" }